import { Component, Input } from '@angular/core';
import { ApiCoverageDetail } from '@bhtp-client-api/base';

@Component({
    selector: 'bonus-coverages',
    template: require('./bonus-coverages.component.html')
})
export class BonusCoveragesComponent {
    @Input() public bonusCoverages: ApiCoverageDetail[] = [];
    @Input() public wasPurchased: boolean = false;
    @Input() public displayCoveragePayoutType: boolean;

    /**
     *  Returns 'are buying' if the user has not purchased, yet.
     *  Returns 'bought' if the user has already purchased.
     */
    public get reasonVerbTense(): string {
        return this.wasPurchased ? 'bought' : 'are buying';
    }

    constructor() { }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/bonus-coverages.component.ts